import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

import type { OnlineShareChannel } from '#src/app/pages/starterDashboardV2/shared/types';

type ShareButtonConfig = Readonly<Record<OnlineShareChannel, { label: TranslationKey; successLabel?: TranslationKey }>>;
export const SHARE_BUTTON_CONFIG: ShareButtonConfig = {
	facebook: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.facebook.share_text'),
	},
	facebookMessenger: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.messenger.share_text'),
	},
	twitter: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.twitter.share_text'),
	},
	whatsapp: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.whatsapp.share_text'),
	},
	instagram: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.instagram.share_text'),
	},
	line: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.line.share_text'),
	},
	email: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.email.share_text'),
	},
	sms: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.sms.share_text'),
	},
	copy: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.copy_link.share_text'),
		successLabel: translationKey(
			'corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.copy_link.success_msg',
		),
	},
	vk: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.vk.share_text'),
	},
	nextdoor: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.nextdoor.share_text'),
	},
	reddit: {
		label: translationKey('corgi.petition.starter_dashboard.grow_petition.share_modal.share_card.reddit.share_text'),
	},
};
